export default __webpack_public_path__ + "static/media/blog-3.04420318.jpg";